import clsx from 'clsx';

import { AvigilonLogoMarkSvg } from 'components/svgs/AvigilonLogoMarkSvg/AvigilonLogoMarkSvg';

import './ProductBranding.scss';

export const ProductBranding = ({
  classes,
  icon,
  label,
  testId,
}: {
  classes?: {
    root?: string;
    text?: string;
  };
  icon?: {
    width?: number;
    height?: number;
  };
  label: string;
  testId: string;
}) => {
  return (
    <div
      className={clsx('product-branding', classes?.root)}
      data-testid={testId}
    >
      <AvigilonLogoMarkSvg width={icon?.width} height={icon?.height} />
      <div className={clsx('product-branding__text', classes?.text)}>
        {label}
      </div>
    </div>
  );
};
